module.exports = __webpack_public_path__ + "static/media/15UN-Habitat3.55306a47.jpg";